import {Directive} from '@angular/core';

@Directive({
    selector: '[appImgCompressor]',
    standalone: false
})
export class ImgCompressorDirective {}
